import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import {
    Archivo_Black,
    Geist,
    Geist_Mono
} from 'next/font/google'

/* The display face — the cut-out words, every headline block, the frame
 * titles. One weight, because Archivo Black only has one. */
const archivoBlack = Archivo_Black({
    variable: '--font-archivo-black',
    weight: '400',
    subsets: ['latin']
})

const geistSans = Geist({
    variable: '--font-sans',
    subsets: ['latin']
})

/* The annotation face — counters, credits, strip numbers, and everything
 * printed on the mat. */
const geistMono = Geist_Mono({
    variable: '--font-geist-mono',
    subsets: ['latin']
})

/* THE FACES ARE DECLARED ON THE DOCUMENT ROOT, not just on the wrapper.
 * The desk is drawn on a canvas, and a canvas cannot read a CSS custom
 * property off an element — the section resolves its two faces with
 * getComputedStyle(document.documentElement), so a variable that only exists
 * further down the tree resolves to nothing and the cut-out words fall back to
 * Impact. Writing the loaded family names here is what keeps the drawn type
 * and the DOM type the same type. */
const ROOT_FACES = `:root{
    --font-archivo-black:${archivoBlack.style.fontFamily};
    --font-geist-mono:${geistMono.style.fontFamily};
    --font-geist-sans:${geistSans.style.fontFamily};
    --font-sans:${geistSans.style.fontFamily};
}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div
            className={`${archivoBlack.variable} ${geistSans.variable} ${geistMono.variable} h-full font-sans antialiased`}
        >
            <style>{ROOT_FACES}</style>

            <Component {...pageProps} />
        </div>
    )
}

export default App
